import { SvgIconProps } from '@mui/material';
import React from 'react';

const DeleteIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="13" cy="13" r="13" fill="#F1F3FF" />
      <path d="M7 9H8.33333H19" stroke="#702DFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.333 8.99967V7.66634C10.333 7.31272 10.4735 6.97358 10.7235 6.72353C10.9736 6.47348 11.3127 6.33301 11.6663 6.33301H14.333C14.6866 6.33301 15.0258 6.47348 15.2758 6.72353C15.5259 6.97358 15.6663 7.31272 15.6663 7.66634V8.99967M17.6663 8.99967V18.333C17.6663 18.6866 17.5259 19.0258 17.2758 19.2758C17.0258 19.5259 16.6866 19.6663 16.333 19.6663H9.66634C9.31272 19.6663 8.97358 19.5259 8.72353 19.2758C8.47348 19.0258 8.33301 18.6866 8.33301 18.333V8.99967H17.6663Z" stroke="#702DFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DeleteIcon; 